// import $ from 'jquery'
// import Vue from "vue";
// // import * as lodash from "lodash";
//时间日期时间戳转正常日期格式
export function changeDate(dateA) {
    var dateee = new Date(dateA).toJSON();
    var date = new Date(+new Date(dateee) + 8 * 3600 * 1000).toISOString().replace(/T/g, ' ').replace(/\.[\d]{3}Z/, '');
    return date;
}
export function dateFormat(time) {
    var date = new Date(time);
    var year = date.getFullYear();
    var month = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;
    var day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
    var hours = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
    var minutes = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
    var seconds = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
    return year + "-" + month + "-" + day + " " + hours + ":" + minutes + ":" + seconds;
}
export function timestampToTime(timestamp) {
    var date = new Date(Number(timestamp)*1000);
    var Y = date.getFullYear() + '-';
    var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
    var D = (date.getDate() < 10 ? '0'+date.getDate() : date.getDate()) + ' ';
    var h = (date.getHours() < 10 ? '0'+date.getHours() : date.getHours()) + ':';
    var m = (date.getMinutes() < 10 ? '0'+date.getMinutes() : date.getMinutes()) + ':';
    var s = (date.getSeconds() < 10 ? '0'+date.getSeconds() : date.getSeconds());

    var strDate = Y+M+D+h+m+s;
    return strDate;

}
//js秒换成天时分
// export function timeStamp(second_time) {
//     var time = parseInt(second_time) + "秒";
//     if (parseInt(second_time) > 60) {
//         var second = parseInt(second_time) % 60;
//         var min = parseInt(second_time / 60);
//         time = min + "分" + second + "秒";
//         if (min > 60) {
//             min = parseInt(second_time / 60) % 60;
//             var hour = parseInt(parseInt(second_time / 60) / 60);
//             time = hour + "小时" + min + "分" + second + "秒";
//             if (hour > 24) {
//                 hour = parseInt(parseInt(second_time / 60) / 60) % 24;
//                 var day = parseInt(parseInt(parseInt(second_time / 60) / 60) / 24);
//                 time = day + "天" + hour + "小时" + min + "分" + second + "秒";
//             }
//         }
//     }
//     return time;
// }
//js 时间戳转日期
// export function getYMDHMS(timestamp) {
//     let time = new Date(timestamp * 1000)
//     let year = time.getFullYear()
//     let month = time.getMonth() + 1
//     let date = time.getDate()
//     let hours = time.getHours()
//     let minute = time.getMinutes()
//     let second = time.getSeconds()
//     if (month < 10) {
//         month = '0' + month
//     }
//     if (date < 10) {
//         date = '0' + date
//     }
//     if (hours < 10) {
//         hours = '0' + hours
//     }
//     if (minute < 10) {
//         minute = '0' + minute
//     }
//     if (second < 10) {
//         second = '0' + second
//     }
//     return year + '-' + month + '-' + date + ' ' + hours + ':' + minute + ':' + second
// }
/**
 * 获取base64格式的回调函数
 * @param URLData 获取的base64格式
 */
//  function getBase64(URLData){
//     //  return "base64" + URLData;
//      console.log("base64",URLData)
//  }

/**
 * Base64转
 * @param base64 String base64格式字符串
 * @param contentType String file对象的文件类型，如："image/png"
 * @param filename String 文件名称或者文件路径
 */
// export function translateBase64ImgToFile(base64,filename,contentType){
//     var arr = base64.split(',')  //去掉base64格式图片的头部
//     var bstr = atob(arr[1])   //atob()方法将数据解码
//     var leng = bstr.length
//     var u8arr = new Uint8Array(leng)
//     while(leng--){
//         u8arr[leng] =  bstr.charCodeAt(leng) //返回指定位置的字符的 Unicode 编码
//     }
//     return new File([u8arr],filename,{type:contentType})
// }
// export function getBase64(img){
//     function getBase64Image(img,width,height) {//width、height调用时传入具体像素值，控制大小 ,不传则默认图像大小
//         var canvas = document.createElement("canvas");
//         canvas.width = width ? width : img.width;
//         canvas.height = height ? height : img.height;
//
//         var ctx = canvas.getContext("2d");
//         ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
//         var dataURL = canvas.toDataURL();
//         return dataURL;
//     }
//     var image = new Image();
//     image.crossOrigin = '';
//     image.src = img;
//     var deferred=$.Deferred();
//     if(img){
//         image.onload =function (){
//             deferred.resolve(getBase64Image(image));//将base64传给done上传处理
//         }
//         return deferred.promise();//问题要让onload完成后再return sessionStorage['imgTest']
//     }}



// WEBPACK FOOTER //
// ./src/utils/index.js